module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans.1ec44b30.ttf";